document.addEventListener('DOMContentLoaded', function () {
  const playVideoButton = document.getElementById("playVideo");
  const stopVideoButton = document.getElementById("stopVideo");
  const thumbContainer = document.getElementById("thumbContainer")
  const videoWrapper = document.getElementById("videoWrapper");
  const videoPlayer = document.getElementById("videoPlayer");
  const header = document.querySelector(".section-header");
  const brandsHeader = document.querySelector(".shopify-section-group-header-group");
  let video;
  if (window.innerWidth > 768) {
    video = document.querySelector(".video-desktop");
  } else {
    video = document.querySelector(".video-mobile");
  }
  function toggleControls() {
    if (video.hasAttribute("controls")) {
      video.removeAttribute("controls")
    } else {
      video.setAttribute("controls", "controls")
    }
  }
  const body = document.body;
  const toggleVideo = function () {
    body.classList.toggle("overflow-hidden");
    brandsHeader.classList.toggle("fixed");
    brandsHeader.classList.toggle("hidden-block");
    header.classList.toggle("fixed");

    toggleControls();
    videoPlayer.classList.toggle("remove-positioning")
    stopVideoButton.classList.toggle("hidden-block")
    playVideoButton.classList.toggle("hidden-block");
    videoWrapper.classList.toggle("video-wrapper");
    thumbContainer.classList.toggle("thumb-desktop-container");
    thumbContainer.classList.toggle("video-container");
  };
  playVideoButton.onclick = () => {
    toggleVideo()
    video.muted = false;
    video.currentTime = 0;
    video.play()
  };

  stopVideoButton.onclick = () => {
    toggleVideo();
    video.muted = true;
    video.play();
  };

})